// Libs
import cx from 'classnames';
// Hooks
import useTheme from 'hooks/useTheme';
// Styles
import styles from './SubTitle.module.css';

const Subtitle = props => {
	const { theme, sharedStyles } = useTheme();
	return (
		<span
			style={{ width: props.width, margin: props.margin }}
			className={cx(
				sharedStyles.standardTextStructure,
				styles.subtitle,
				theme.mediumEmphasisColor,
				{
					[sharedStyles.ellipsis]: !!props.ellipsis,
					[sharedStyles.cursorPointer]: !!props.cursorPointer,
					[sharedStyles.wordBreak]: !!props.wordBreak,
					[sharedStyles.uppercase]: !!props.uppercase,
					[sharedStyles[`textAlign_${props.textAlign}`]]: !!props.textAlign,
					[theme.highEmphasisColor]: !!props.emphasis,
					[theme.hoverable]: !!props.hoverable,
					[theme.inactiveColor]: !!props.disabled,
				},
			)}
		>
			{props.children}
		</span>
	);
};

export default Subtitle;
